import Vue from 'vue'

function add_vue_property(name, value) {
    Object.defineProperty(Vue.prototype, name, {
        get() {
            return value;
        },
    });
};

export default add_vue_property



// WEBPACK FOOTER //
// ./src/utils/add_vue_property.js